import categoryType from '@/utils/constants/stipulation55CategoryType';

export default Object.freeze([
  {
    id: 1,
    name: categoryType.COMPANION_EDUCATIONAL,
  },
  {
    id: 2,
    name: categoryType.ADDITION_EDUCATIONAL,
  },
  {
    id: 3,
    name: categoryType.COMPANION_THERAPY,
  },
  {
    id: 4,
    name: categoryType.ADDITION_THERAPY,
  },
]);
